export const scrollToClass = (className: string, delay = 300): void => {
  const $el = document.querySelector(`${className}`);
  if ($el) {
    scrollToElement($el, delay);
  }
};

export const scrollToElement = (element: Element, delay = 300): void => {
  setTimeout(() => {
    element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, delay);
};
